import { Navigate, useLocation } from "react-router-dom";
import { useDealerSession } from "@/hooks/useDealerSession";

interface RequireDealerAuthProps {
    children: React.ReactNode;
}

/**
 * Only renders children if dealer is logged in.
 * Otherwise redirects to /dealer/login.
 */
export function RequireDealerAuth({ children }: RequireDealerAuthProps) {
    const { user, loading } = useDealerSession();
    const location = useLocation();

    // ⏳ Still verifying session — don't redirect yet
    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center text-muted-foreground">
                Checking session…
            </div>
        );
    }

    // 🚫 Not logged in — redirect to login (not signup)
    if (!user) {
        return (
            <Navigate
                to="/dealer/signup"
                replace
                state={{ from: location }}
            />
        );
    }

    // ✅ Authorized — render protected page
    return <>{children}</>;
}
